import { isNetskopeAccess } from './accessRoute';

function reactAppBase() {
    const intranetBase = process.env.VUE_APP_REACT_APP_URL || 'https://isend.itrack.redekasa.com';
    // Acesso externo pelo Netskope: o host interno do app React nao e alcancavel,
    // entao usa o private app do proxy quando configurado.
    if (isNetskopeAccess() && process.env.VUE_APP_NETSKOPE_REACT_APP_URL) {
        return process.env.VUE_APP_NETSKOPE_REACT_APP_URL;
    }
    return intranetBase;
}

export function reactAppUrl(path) {
    const base = reactAppBase().replace(/\/$/, '');
    const useHash = String(process.env.VUE_APP_REACT_APP_USE_HASH || 'false').toLowerCase() !== 'false';
    const prefix = useHash ? `${base}/#` : base;
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${prefix}${normalizedPath}`;
}
